import HtmlTrans from 'components/shared/HtmlTrans';
import { Heading2 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import {
  StyledContainer,
  StyledHeader,
  StyledItem,
  StyledItemCase,
  StyledItemCaseTitle,
  StyledItemContent,
  StyledItemImage,
  StyledItemTag,
  StyledItemTitle,
  StyledList,
  StyledWrapper
} from './ConsultancyCases.styled';
import { CaseItem } from '../../ConsultancyComponent.types';
import MarkdownComponent from 'components/shared/MarkdownComponent';

type ContentProps = {
  cases: CaseItem[];
};

const ConsultancyCases: React.FC<ContentProps> = ({ cases }) => {
  const { t } = useI18n('consultancy');

  return (
    <StyledWrapper>
      <StyledContainer>
        <StyledHeader>
          <Heading2 editorial>{t('consultancy.cases.title')}</Heading2>
          <HtmlTrans ns={'consultancy'} i18nKey={'consultancy.cases.desc'} />
        </StyledHeader>
        <StyledList>
          {cases.map((item, index) => (
            <StyledItem key={index}>
              <StyledItemImage
                src={item.attributes.image.data.attributes.url}
              />
              <StyledItemContent>
                <StyledItemTitle>{item.attributes.title}</StyledItemTitle>
                <StyledItemTag>{item.attributes.duration}</StyledItemTag>
                <MarkdownComponent content={item.attributes.description} />
                <StyledItemCase>
                  <img
                    src={item.attributes.thumbnail.data.attributes.url}
                    alt=""
                  />
                  <div>
                    <StyledItemCaseTitle>
                      {t('consultancy.cases.success-case')}
                    </StyledItemCaseTitle>
                    <a href={item.attributes.successCaseUrl}>
                      {item.attributes.successCaseTitle}
                    </a>
                  </div>
                </StyledItemCase>
              </StyledItemContent>
            </StyledItem>
          ))}
        </StyledList>
      </StyledContainer>
    </StyledWrapper>
  );
};

export default ConsultancyCases;
